import { useEffect } from "react";

// Lightweight SEO helper — updates <title>, <meta description>, JSON-LD on mount.
export function useSEO({ title, description, image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (key, value, attr = "name") => {
      if (!value) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }
    if (title) {
      setMeta("og:title", title, "property");
      setMeta("twitter:title", title);
    }
    if (image) {
      setMeta("og:image", image, "property");
      setMeta("twitter:image", image);
    }

    // JSON-LD injection
    let scriptEl = null;
    if (jsonLd) {
      scriptEl = document.createElement("script");
      scriptEl.type = "application/ld+json";
      scriptEl.textContent = JSON.stringify(jsonLd);
      scriptEl.setAttribute("data-seo-dynamic", "true");
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl && scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
    };
  }, [title, description, image, JSON.stringify(jsonLd)]);
}
